import { render } from "./LocaleSwitcher.vue?vue&type=template&id=6352111a&scoped=true"
import script from "./LocaleSwitcher.vue?vue&type=script&lang=js"
export * from "./LocaleSwitcher.vue?vue&type=script&lang=js"

import "./LocaleSwitcher.vue?vue&type=style&index=0&id=6352111a&scoped=true&lang=css"
import "./LocaleSwitcher.vue?vue&type=style&index=1&id=6352111a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6352111a"]])

export default __exports__